export default __webpack_public_path__ + "static/media/E2BAuto-320x480-px.34ddd637.jpg";